import styled from 'styled-components';

import { CollapsibleSection } from './collapsible-section';

interface Props {
  payload: Record<string, unknown>;
}

const Pre = styled.pre`
  margin: 0;
  padding: 12px 14px;
  background: ${({ theme }) => theme.colors.bgMuted};
  border-radius: ${({ theme }) => theme.radius.md};
  border: 1px solid ${({ theme }) => theme.colors.border};
  font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace;
  font-size: 12px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.textPrimary};
  max-height: 480px;
  overflow: auto;
  white-space: pre;
`;

export const PayloadTecnicoSection = ({ payload }: Props) => (
  <CollapsibleSection
    title="Payload técnico (JSON)"
    testId="produto-section-payload"
  >
    <Pre data-testid="produto-payload-json">
      {JSON.stringify(payload, null, 2)}
    </Pre>
  </CollapsibleSection>
);
